export default __webpack_public_path__ + "static/media/Signup3.fb917922.png";